module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/keepCoolExpired-6ca7b47ff2484639ca929820dadf9045.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/keepCoolExpired.png
// module id = 2451
// module chunks = 2